// @ts-nocheck
import { FC, ReactNode, useRef, CSSProperties } from 'react';
import { ProButton, ProSpace, ProCol } from '../antd';
import {
  SearchOutlined,
  FilterOutlined,
  UndoOutlined,
} from '@ant-design/icons';
import {
  SearchFormItemEnum,
  BaseSearchFormItemProps,
} from './interface/baseInterface';
import { ButtonType, ButtonProps } from 'antd/lib/button';
import { FormInstance } from 'antd/lib/form';

const btnStyle: CSSProperties = { padding: '0 8px' };
export interface SearchFormOperationProps extends BaseSearchFormItemProps {
  /** form表单实例 */
  form?: FormInstance;
  /** 搜索按钮文字 */
  searchText?: ReactNode;
  /** 搜索按钮图标 */
  searchIcon?: ReactNode;
  /** 搜索按钮type */
  searchType?: ButtonType;
  /** 搜索按钮是否处于加载中 */
  searchLoading?: boolean;
  /** 搜索按钮props */
  searchButtonProps?: ButtonProps;
  /** 重置按钮文字 */
  resetText?: ReactNode;
  /** 重置按钮图标 */
  resetIcon?: ReactNode;
  /** 重置按钮是否处于加载中 */
  resetLoading?: boolean;
  /** 是否隐藏重置按钮 */
  hideReset?: boolean;
  /** 是否需要展示高级查询按钮 */
  highSearch?: boolean;
  /** 是否显示高级查询 */
  showSearch?: boolean;
  /** 点击高级查询是触发 */
  onHighSearch?: (event?: HTMLElement) => void;
  /** 点击重置是触发 */
  onReset?: () => void;
}
/** 操作按钮 */
export const SearchFormOperation: FC<SearchFormOperationProps> = props => {
  const {
    searchText,
    searchIcon,
    searchType,
    searchLoading,
    searchButtonProps,
    resetText,
    resetIcon,
    resetLoading,
    hideReset,
    form,
    children,
    highSearch,
    showSearch,
    onHighSearch,
    onReset,
    testId,
    ...resProps
  } = props;
  const highRef = useRef<any>();
  // 重置
  const handleReset = () => {
    form && form.resetFields();
    onReset && onReset();
  };
  // 高级查询
  const handleClick = () => {
    onHighSearch && onHighSearch(highRef.current);
  };
  /** 搜索 */
  const handleSubmit = () => {
    form?.submit();
  };
  return (
    <ProCol
      {...resProps}
      className="yb-form-item-operation"
    >
      <ProSpace size="middle" align="center">
        {children ? (
          children
        ) : (
          <>
            {!hideReset && (
              <>
                {resetText ? (
                  <ProButton
                    icon={resetIcon}
                    style={btnStyle}
                    loading={resetLoading}
                    onClick={handleReset}
                    className="serch-form-reset"
                    test-id={`${testId}-reset`}
                  >
                    {resetText}
                  </ProButton>
                ) : (
                  <ProButton
                    title="重置"
                    icon={resetIcon}
                    style={btnStyle}
                    loading={resetLoading}
                    onClick={handleReset}
                    className="serch-form-reset"
                    test-id={`${testId}-modal-reset`}
                  />
                )}
              </>
            )}
            <div
              className={highSearch ? 'yb-form-search-high-search' : ''}
              style={{
                minWidth: highSearch ? '100px' : '60px',
              }}
            >
              <ProButton
                style={btnStyle}
                icon={searchIcon}
                type={searchType}
                loading={searchLoading}
                className="serch-form-search"
                test-id={`${testId}-search`}
                onClick={handleSubmit}
                {...searchButtonProps}
              >
                {searchText}
              </ProButton>
              {highSearch && (
                <ProButton
                  type="primary"
                  style={btnStyle}
                  onClick={handleClick}
                  ref={highRef}
                  title="更多筛选"
                  className="serch-form-high-search"
                  test-id={`${testId}-high-search`}
                >
                  <FilterOutlined />
                </ProButton>
              )}
            </div>
          </>
        )}
      </ProSpace>
    </ProCol>
  );
};

SearchFormOperation.displayName = SearchFormItemEnum.SearchFormOperation;

SearchFormOperation.defaultProps = {
  searchText: '查询',
  searchIcon: <SearchOutlined />,
  searchType: 'primary',
  searchLoading: false,
  resetText: '重置',
  resetIcon: <UndoOutlined />,
  resetLoading: false,
  hideReset: false,
  highSearch: false,
  showSearch: false,
};

export default SearchFormOperation;
